import { DetachableElement } from '@99designs/common/components/DetachableElement';
import { FixedViewportElement } from '@99designs/common/components/FixedViewportElement';
import React from 'react';

interface Props {
    isAnimating?: boolean;
}

export const DetachedOverlay: React.FunctionComponent<Props> = ({ isAnimating, children }) => (
    <>
        {/* We don't want to wrap our component with this because React will force a rerender if we
        remove it */}
        {!isAnimating && <FixedViewportElement children={null} />}
        <DetachableElement>
            <div className="detached-overlay">
                <div className="detached-overlay__content">{children}</div>
            </div>
        </DetachableElement>
    </>
);
